import { IEnvironmentModel } from './environment.model';

export const internalEnvironment: IEnvironmentModel = {
  type: 'internal',
  production: false,
  dev: false,
  domain: 'di.hrm.int.test.visma.net',

  // logging
  enableBrowserLogs: true,
  enableRUM: false,

  // authentication and client IDs
  dummyAuth: true,
  signinUrl: '',
  loginRedirectUrl: '',
  oauth: {
    issuer: undefined,
    clientId: 'VismaNetHrmDataImport',
  },
  ldClientSideID: '608646cc9151340be39d6364',
  survicateWorkspaceKey: null,

  // APIs
  dataImportApiBaseUrl: 'https://api.di.hrm.int.test.visma.net',
  staticJsonApiBaseUrl: 'https://static-json.no.stag.visma.net/',
  wsBaseUrl: 'wss://ws.di.hrm.int.test.visma.net',

  // external links
  empManModuleId: 2257,
  vismaHomeUrl: 'https://home.stag.visma.com/',
  vismaEmpmanUrl: 'https://web.employeecore1.hrm.stag.visma.net/uiempmanapp/',
  vismaAboutUrl: 'https://wagerun.cj.hrm.int.test.visma.net/',
  vismaCalendarUrl: 'https://web.calendar.hrm.int.test.visma.net/',
  payrollUiUrl: 'https://payrollui.no.int.test.visma.net/',
  payrollPortal:
    'https://web.calendar.hrm.stag.visma.net/absence/_Svelte/dist/scripts/es/ClientPortalComponentProvider.js',
  wagerunUrl: 'https://wagerun.cj.hrm.stag.visma.net',
  accountSettingsUrl: 'https://accountsettings.connect.identity.stagaws.visma.com/',

  // embedded components
  timeDocumentsUrl:
    'https://ui.time.hrm.int.test.visma.net/timeui/dist/clientportal-component-provider.js',
  variableTransactionsUrl:
    'https://wagerun.cj.hrm.int.test.visma.net/componentProviders/employeeTransactionsProviderV1.js',
  employeeRecurringUrl:
    'https://wagerun.cj.hrm.int.test.visma.net/componentProviders/employeeRecurringProvider.js',
  assistant: {
    apiBaseUrl: undefined,
    profileId: 'payroll-prod',
  },
  walkmeSrc:
    'https://eu-cdn.walkme.com/users/156f0c8fa19a4b7cbd7437d888ce43cc/test/walkme_private_156f0c8fa19a4b7cbd7437d888ce43cc_https.js',
  walkmeIntegrity: 'sha256-xA7YXeCjh992RrqQgJYVJkaC1WKs0iPQ4lE/tNN65b4=',
};
